import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { Text1 } from '../../../styles';
import VerificationForm from '../Forms/VerificationForm';


const VerificationModal = (props) => {
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>Verification</Text1>
        )
    };

    return (
        <EaseModal
            width={500}
            title={false}
            visible={props.visible}
            onCancel={props.toggleVerificationModal}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <VerificationForm
                onVerify={props.onVerify}
                loading={props.loading}
            />
        </EaseModal>
    )
};

export { VerificationModal };